'use strict';

// Assigned Dependencies
module.exports = (function() {
	setupContentSliderButtons();
    setupFullHeightBlockHeights();
    $(window).resize(function() {
       setupFullHeightBlockHeights();
    });
})();

function setupContentSliderButtons() {
	
    var containerSelector = '.full-height-block';
    var numContainers = $(containerSelector).length;

    $(containerSelector).each(function(index, element){
        var nextEl = $(this).next();
        var parent = $(this).parent();
        var noArrow= $(this).hasClass('no-arrow');

        if (!noArrow && $(this).find('.button-container').length > 0 && (index < numContainers - 1 || numContainers == 1)) { 
            var css = $(this).find('.button-container').attr('data-color');
            var buttonHtml = '<div class="button-container"><button class="button content-slider '+css+'"><span class="icon-arrow-down"></span></button></div>';
            $(this).append(buttonHtml);
        }
    });

    $('.content-slider').click(function() {
    	// Get the next visible element for the reference point
    	var nextEl = $(this).parents(containerSelector).nextAll("*:visible").first();
        if (typeof(nextEl) !== 'undefined' && nextEl.length > 0) {
            $(this).blur();
            window.moveWindowToElement(nextEl, 0, 1000); 
        }
    });
}

function setupFullHeightBlockHeights() {
    $('.full-height-block.first').removeClass('height-calc-ready').removeClass('height-calc-ready-fits-screen');
    $('.full-height-block.first').each(function(){
            var extraHeight = $(this).find('.side-panel').length > 0 ? $(this).find('.side-panel').height() : 0;
            var totalHeightThisElementNeeds = $(this).height() + extraHeight;
            var screenHeight = window.innerHeight;
            var navHeight = $('.top-header').is(':visible') ? $('.top-header').height() + $('.main-navigation').height() : $('.main-navigation').height();
            var totalHeightElementAndNav =parseInt(totalHeightThisElementNeeds) + navHeight;
            if (screenHeight >= totalHeightElementAndNav) {
                $(this).addClass('height-calc-ready-fits-screen');
            }
            else {
                 $(this).addClass('height-calc-ready');
            }
        });
}